function create() {
  let roomId = null;
  const flags = [];
  return {
    awaitCompose: false,
    setRoom(id) {
      if (id !== roomId) {
        flags.length = 0;
        roomId = id;
      }
    },
    add(ack) {
      if (!ack?.id) return;
      if (flags.some((f) => f.id === ack.id)) return;
      flags.push({ id: ack.id, createdAt: ack.createdAt, summary: ack.summary, note: null });
    },
    markNoted(id) {
      const f = flags.find((x) => x.id === id);
      if (f) f.note = f.note || '(noted)';
    },
    pending() { return flags.filter((f) => !f.note); },
    get roomId() { return roomId; }
  };
}

const FlagStore = { create };
export { FlagStore };
